var React = require('react');

function MenuShapeRewindInline (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"717.82 603.71 495.07 27.09 318.13 426.77 717.82 603.71","fill":"none","stroke":"#f0f","strokeMiterlimit":"10","key":0}),React.createElement("polygon",{"points":"425.17 716.87 202.42 140.25 25.48 539.94 425.17 716.87","fill":"none","stroke":"#f0f","strokeMiterlimit":"10","key":1})]);
}

MenuShapeRewindInline.defaultProps = {"viewBox":"0 0 750 750"};

module.exports = MenuShapeRewindInline;

MenuShapeRewindInline.default = MenuShapeRewindInline;
